var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotatedArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.189 12.0969C11.586 12.0925 11.9065 11.7711 11.9098 11.3741L11.9916 1.51814C11.9962 0.958827 11.5428 0.504426 10.9835 0.509351C8.16077 0.534203 3.81983 0.565168 1.11574 0.589542C0.722606 0.593086 0.405844 0.909437 0.399385 1.30253C0.392683 1.71046 0.723573 2.04362 1.13154 2.03994C2.91631 2.0238 5.00998 2.00908 7.06785 1.99285C7.96312 1.98579 8.41706 3.06855 7.78399 3.70161L0.507288 10.9783C0.227121 11.2584 0.227118 11.7127 0.507283 11.9928C0.787448 12.273 1.24169 12.273 1.52185 11.9928L8.79864 4.71607C9.4317 4.08302 10.5138 4.537 10.5057 5.43224L10.452 11.3614C10.4484 11.7697 10.7807 12.1014 11.189 12.0969Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotatedArrow);
export default __webpack_public_path__ + "static/media/rotatedArrow.1d32733139482cbcdd30f389d2b34cbf.svg";
export { ForwardRef as ReactComponent };